export default "__VITE_ASSET__f3823953__"